import { defaultApiState } from '../api.state';

export const appointmentMutations = {
  GET_APPOINTMENTS_LOADING(state) {
    state.apiState.getAppointments = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_APPOINTMENTS_SUCCESS(state, payload) {
    state.apiState.getAppointments = {
      ...defaultApiState,
      success: true,
    };
    state.appointments = payload;
  },
  GET_APPOINTMENTS_ERROR(state, error) {
    state.apiState.getAppointments = {
      ...defaultApiState,
      error,
    };
  },
  GET_APPOINTMENT_LOADING(state) {
    state.apiState.getAppointment = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_APPOINTMENT_SUCCESS(state, payload) {
    state.apiState.getAppointment = {
      ...defaultApiState,
      success: true,
    };
    state.appointment = payload;
  },
  GET_APPOINTMENT_ERROR(state, error) {
    state.apiState.getAppointment = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_APPOINTMENT_LOADING(state) {
    state.apiState.updateAppointment = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_APPOINTMENT_SUCCESS(state, payload) {
    state.apiState.updateAppointment = {
      ...defaultApiState,
      success: true,
    };
    state.appointment = payload;
  },
  UPDATE_APPOINTMENT_ERROR(state, error) {
    state.apiState.updateAppointment = {
      ...defaultApiState,
      error,
    };
  },
};
